import { FormSkeleton } from '@globaleris/ui.library'
import { Box, makeStyles, Typography, useTheme } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { styles } from './tankForm.styles'

export const LoadingForm: React.FC<{}> = React.memo(() => {
  const [t] = useTranslation(['globalerisLibrary', 'tanks', 'enums'])
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  //#endregion

  return (
    <>
      <Box ml={2} mt={12}>
        <Typography variant="subtitle1" color="primary" className={classes.tableTitles}>
          {t('tanks:forms.add.titleTank')}
        </Typography>
      </Box>
      <FormSkeleton withTitle={false} elevation={0} columns={3} inputs={9} />
    </>
  )
})
